import * as R from 'ramda';
import { httpGet, httpPost, httpPut, httpPatch } from 'apiModule/rest';
import adapter from 'dataModule/adapter';
import { getQueriesString, getIdsObject } from 'utilsModule';

const saveProblemHistory = async ({ content }) =>
  R.pipe(adapter.problems.saveProblemHistory.fe2be, httpPost('problems/problemHistory'), (response) =>
    response.then(adapter.problems.saveProblemHistory.be2fe),
  )(content);

const updateProblemHistory = async ({ content, params: { ids } }) => {
  const url = R.pipe(getIdsObject, ({ problemId }) => `problems/problemHistory/${problemId}`)(ids);

  return R.pipe(adapter.problems.updateProblemHistory.fe2be, httpPut(url), (response) =>
    response.then(adapter.problems.updateProblemHistory.be2fe),
  )(content);
};

const getProblemHistory = async ({ params: { queries } }) => {
  return R.pipe(
    getQueriesString,
    (queriesString) => httpGet(`problems/problemHistory${queriesString}`),
    (response) => response.then(adapter.problems.getProblemHistory.be2fe),
  )(queries);
};

const archiveProblem = async ({ content, params: { ids } }) => {
  const url = R.pipe(getIdsObject, ({ problemId }) => `problems/problemHistory/${problemId}/archive`)(ids);

  return R.pipe(adapter.problems.archiveProblem.fe2be, httpPut(url), (response) =>
    response.then(adapter.problems.archiveProblem.be2fe),
  )(content);
};

const deleteProblem = async ({ content, params: { ids } }) => {
  const url = R.pipe(getIdsObject, ({ problemId }) => `problems/problemHistory/${problemId}/delete`)(ids);

  return R.pipe(adapter.problems.deleteProblem.fe2be, httpPut(url), (response) =>
    response.then(adapter.problems.deleteProblem.be2fe),
  )(content);
};

const addProblemNote = async ({ content }) =>
  R.pipe(adapter.problems.addProblemNote.fe2be, httpPost('problems/problemHistory/note'), (response) =>
    response.then(adapter.problems.addProblemNote.be2fe),
  )(content);

const getProblemNotes = async ({ params: { queries } }) => {
  return R.pipe(
    getQueriesString,
    (queriesString) => httpGet(`problems/problemHistory/note${queriesString}`),
    (response) => response.then(adapter.problems.getProblemNotes.be2fe),
  )(queries);
};

const markProblemNoteAsError = async ({ content }) =>
  R.pipe(adapter.problems.markProblemNoteAsError.fe2be, httpPost('problems/problemHistory/note/markNoteAsError'), (response) =>
    response.then(adapter.problems.markProblemNoteAsError.be2fe),
  )(content);

const DM = {
  saveProblemHistory,
  updateProblemHistory,
  getProblemHistory,
  archiveProblem,
  deleteProblem,
  addProblemNote,
  getProblemNotes,
  markProblemNoteAsError
};

const ajax = async ({ method, input }) => ({ [method]: await DM[method](input) });

export default { ...DM, ajax };
